import { render, staticRenderFns } from "./PesertaPelatihanEvaluasiPenyelenggara.vue?vue&type=template&id=25e7b883&scoped=true&"
import script from "./PesertaPelatihanEvaluasiPenyelenggara.vue?vue&type=script&lang=js&"
export * from "./PesertaPelatihanEvaluasiPenyelenggara.vue?vue&type=script&lang=js&"
import style0 from "./PesertaPelatihanEvaluasiPenyelenggara.vue?vue&type=style&index=0&id=25e7b883&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e7b883",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VRadio,VRadioGroup,VRow,VSimpleTable,VTextarea})
